import { Outlet, createFileRoute } from '@tanstack/react-router'
import { TvLayout } from '@/widgets/layouts/tv-layout'

// Unauthenticated until the TV session model is decided (docs/open-questions.md Q7).
export const Route = createFileRoute('/tv')({
  component: () => (
    <TvLayout>
      <Outlet />
    </TvLayout>
  ),
})
